export const DEFAULT_MONTHLY_SPEND = 2500;
export const DEFAULT_PURCHASE_SPEND = 2500;
export const DEFAULT_SECURITY_DEPOSIT = 200;
